export default __webpack_public_path__ + "i18n/ko.4f1c5bc4ad20f37e7c8b4826dee91f12.json";